"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Card = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Card = require("./Card.style");

var _spacing = require("../../system/spacing.style");

var _colors = require("../../themes/colors.theme");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var Card = function Card(props) {
  var children = props.children,
      tag = props.tag;
  return _react.default.createElement(_Card.StyledCard, _extends({
    as: tag
  }, props), children);
};
/**
 * Definition of default values for component props
 */


exports.Card = Card;
Card.defaultProps = {
  children: undefined,
  tag: 'div',
  margin: '0 0 1rem 0',
  borderCollapse: false,
  inset: undefined,
  className: undefined,
  id: undefined,
  shadow: undefined,
  borderAll: true,
  borderRight: false,
  borderLeft: false,
  borderTop: false,
  borderBottom: false,
  borderRadius: true,
  borderColor: undefined,
  borderWidth: '1px',
  backgroundColor: undefined
};
Card.propTypes = {
  /** cards need content */
  children: _propTypes.default.node,

  /** use li for a group of cards */
  tag: _propTypes.default.oneOf(['li', 'div']),

  /** margin around a card */
  margin: _propTypes.default.string,

  /** padding defined by spacing system */
  inset: _spacing.insetPropType,

  /** Collapse borders between neighboring cards in a deck */
  borderCollapse: _propTypes.default.bool,

  /** Component className */
  className: _propTypes.default.string,

  /** Component id */
  id: _propTypes.default.string,

  /** The shadow strength */
  shadow: _propTypes.default.oneOf(['shadow300', 'shadow500', 'shadow700', undefined]),

  /** Border props */
  borderAll: _propTypes.default.bool,
  borderRight: _propTypes.default.bool,
  borderLeft: _propTypes.default.bool,
  borderTop: _propTypes.default.bool,
  borderBottom: _propTypes.default.bool,
  borderRadius: _propTypes.default.bool,
  borderColor: _propTypes.default.oneOf(Object.values(_colors.colors)),
  borderWidth: _propTypes.default.string,
  backgroundColor: _propTypes.default.oneOf(Object.values(_colors.colors))
};